<template>
  <Page>
    <section class="mathinelogs-container">
      <Announce style="margin-top: 8px;" />
      
      <Breadcrumb title="机器日志" />
      <ListFilter :formList="filterFormList" @search="searchHandle" />
      <div class="logs-list">
        <el-table v-sticky="{ top: 140, parent: '.mathinelogs-container', zIndex: 996 }" :data="list" style="width: 100%; color: #232326;" :header-cell-style="{ fontWeight: 500, color: '#232326', backgroundColor: '#F8F9FA' }">
          <template #empty><Empty style="margin-top: 56px;" /></template>
          <el-table-column prop="id" label="机器ID" />
          <el-table-column prop="name" label="机器名称" show-overflow-tooltip />
          <el-table-column prop="toBeExecutedCount" label="待执行子任务数" show-overflow-tooltip />
          <el-table-column prop="status" label="状态" width="156">
            <template #default="scope">
              <span class="statusitem"><em :style="{ backgroundColor: CONST.MATHINE_STATUS_COLOR[scope.row.status] }" />{{ CONST.MATHINE_STATUS_LABEL[scope.row.status] }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="edit" label="操作" align="right">
            <template #default="scope">
              <el-button link type="primary" @click="updateHandle(scope.row)">更新</el-button>
              <!-- <el-button link type="primary" @click="detailHandle(scope.row)">详情</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <Spagination 
          wstyle="margin-top: 24px"
          :page="page"
          :size="size"
          :total="total"
          @current-change="val => page = val"
        />
      </div>
    </section>

    <!-- <el-dialog v-model="detailFlag" title="详情" width="83%">
      <el-table :data="detailObj?.list" style="width: 100%; height: 80%; color: #232326;" :header-cell-style="{ fontWeight: 500, color: '#232326', backgroundColor: '#F8F9FA' }">
        <el-table-column prop="pid" label="任务ID" />
        <el-table-column prop="id" label="子任务ID" />
        <el-table-column prop="machineName" label="机器名称" />
        <el-table-column prop="status" label="子任务状态" />
        <el-table-column prop="rt" label="用时" />
        <el-table-column prop="createdTime" label="开始时间" />
        <el-table-column prop="updatedTime" label="更新时间" />
      </el-table>
    </el-dialog> -->
  </Page>
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue';
  import Empty from '@/components/empty';
  import Page from '@/components/page';
  import Breadcrumb from '@/components/breadcrumb';
  import ListFilter from '@/components/listFilter';
  import Spagination from '@/components/spagination';
  import Announce from '@/components/announce';

  import * as Request from '@/assets/request';
  import * as CONST from '@/assets/const';
  import * as Utils from '@/assets/utils';
  import { ElMessage } from 'element-plus';

  /**
   * 搜索
   */
  const filterFormList = ref([])
  const filterFormListInit = () => {
    filterFormList.value = [
    {
        type: 'select', field: 'machineId',
        label: '执行机器', placeholder: '请选择',
        options: []
      },
      {
        type: 'select', field: 'status',
        label: '状态', placeholder: '请选择',
        options: Object.keys(CONST.MATHINE_STATUS_LABEL).map(value => ({ value: Number(value), label: CONST.MATHINE_STATUS_LABEL[value] }))
      },
    ]
  }
  onMounted(() => {
    filterFormListInit()
  })
  // 获取所有app
  const getMachines = async () => {
    const result = await Request.post({
      url: '/22001/facade/dispatch/machines'
    });
    if(result?.code != 200) return;

    let _options = [];
    if(result?.data?.length > 0) {
      result.data.map(item => {
        _options.push({ value: item?.id, label: item?.name })
      })
    }
    filterFormList.value.map(item => {
      if(item?.field == 'machineId') {
        item.options = _options
      }
      return item;
    });
    console.log('filterFormList.value', filterFormList.value)
  }
  onMounted(() => {
    getMachines()
  })

  /**
   * 列表
   */
  const list = ref([])
  const listQuery = ref({})
  const total = ref(0)
  const size = ref(50)
  const page = ref(1)
  const getList = async () => {
    const result = await Request.post({
      url: '/22001/facade/machine/log/searchList',
      data: {
        ...listQuery.value,
        page: page.value,
        size: size.value
      }
    });
    if(result?.code != 200) return;

    list.value = result.data.content;
    // list.value = [...result.data.content,...result.data.content,...result.data.content,...result.data.content,...result.data.content];
    total.value = result.data.total;
  }
  onMounted(() => {
    getList()
  })
  onMounted(() => {
    getList()
  })
  watch(() => [ listQuery.value, page.value ], () => {
    getList();
  }, { deep: true });
  
  // 搜索
  const searchHandle = data => {
    listQuery.value = { ...data };
    page.value = 1;
  }

  /**
   * 操作
   */
  // 停止
  const stopHandle = async (item) => {
    
  }

  // 更新
  const updateHandle = async (item) => {
    const result = await Request.post({
      url: '/22001/facade/machine/log/update',
      data: item?.id
    });
    if(result?.code != 200) return;

    ElMessage.success('更新成功');
    getList()
  }

  // 详情
  const detailFlag = ref(false)
  const detailObj = ref(null)
  const detailHandle = async (item) => {
    detailFlag.value = true;
    detailObj.value = {
      title: '',
      list: [
        { pid: '任务ID', id: '子任务ID', machineName: '机器名称', status: '子任务状态', rt: '用时', createdTime: '开始时间', updatedTime: '更新时间' },
        { pid: '任务ID', id: '子任务ID', machineName: '机器名称', status: '子任务状态', rt: '用时', createdTime: '开始时间', updatedTime: '更新时间' },
        { pid: '任务ID', id: '子任务ID', machineName: '机器名称', status: '子任务状态', rt: '用时', createdTime: '开始时间', updatedTime: '更新时间' },
        { pid: '任务ID', id: '子任务ID', machineName: '机器名称', status: '子任务状态', rt: '用时', createdTime: '开始时间', updatedTime: '更新时间' },
        { pid: '任务ID', id: '子任务ID', machineName: '机器名称', status: '子任务状态', rt: '用时', createdTime: '开始时间', updatedTime: '更新时间' },
        { pid: '任务ID', id: '子任务ID', machineName: '机器名称', status: '子任务状态', rt: '用时', createdTime: '开始时间', updatedTime: '更新时间' },
        { pid: '任务ID', id: '子任务ID', machineName: '机器名称', status: '子任务状态', rt: '用时', createdTime: '开始时间', updatedTime: '更新时间' },
        { pid: '任务ID', id: '子任务ID', machineName: '机器名称', status: '子任务状态', rt: '用时', createdTime: '开始时间', updatedTime: '更新时间' },
        { pid: '任务ID', id: '子任务ID', machineName: '机器名称', status: '子任务状态', rt: '用时', createdTime: '开始时间', updatedTime: '更新时间' },
        { pid: '任务ID', id: '子任务ID', machineName: '机器名称', status: '子任务状态', rt: '用时', createdTime: '开始时间', updatedTime: '更新时间' },
        { pid: '任务ID', id: '子任务ID', machineName: '机器名称', status: '子任务状态', rt: '用时', createdTime: '开始时间', updatedTime: '更新时间' },
        { pid: '任务ID', id: '子任务ID', machineName: '机器名称', status: '子任务状态', rt: '用时', createdTime: '开始时间', updatedTime: '更新时间' },
        { pid: '任务ID', id: '子任务ID', machineName: '机器名称', status: '子任务状态', rt: '用时', createdTime: '开始时间', updatedTime: '更新时间' },
      ]
    }
  }
</script>

<style scoped lang="less">
@import "./index.less";
</style>
